import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import CommercialInvoiceDetailContent from './content';
import './index.scss';
import { t } from 'i18next';
function DetailDialog({ data, modalOpen, onToggle }) {
  return (
    <Modal isOpen={modalOpen} size='lg' backdrop={true} style={{ top: '1%' }}>
      <div className=' modal-header' style={{ background: '#e9e9ef' }}>
        <h5 className=' modal-title'>{t('commercial_invoice.commercial_invoice')}</h5>
        <button aria-label='Close' className=' close' type='button' onClick={() => onToggle(!modalOpen)}>
          <span aria-hidden={true}>×</span>
        </button>
      </div>

      <ModalBody className='order-detail-dialog'>
        <CommercialInvoiceDetailContent data={data} />
      </ModalBody>
    </Modal>
  );
}
export default DetailDialog;
